<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex xs12 md8>
        <v-card class="pa-3">
          <v-card-title class="headline px-0 pt-0"
            >Send Notification</v-card-title
          >
          <v-autocomplete
            v-model="selectedUsers"
            :items="users"
            item-text="label"
            item-value="userName"
            multiple
            chips
            small-chips
            deletable-chips
            label="Users"
            :loading="loadingUsers"
          ></v-autocomplete>
          <div class="mb-3">
            <v-btn
              small
              outline
              color="success"
              :disabled="!users.length"
              @click="toggleAll"
              >{{ allSelected ? "Clear" : "Select all" }}</v-btn
            >
            <span class="grey--text ml-2"
              >{{ selectedUsers.length }} selected</span
            >
          </div>
          <v-text-field
            v-model="title"
            label="Title"
            counter="255"
            :rules="[rules.required, rules.titleLength]"
          ></v-text-field>
          <v-textarea
            v-model="description"
            label="Description"
            :rules="[rules.required]"
          ></v-textarea>
          <v-layout row wrap>
            <!-- <v-flex xs12 sm4 class="pr-2">
              <v-select
                v-model="urgency"
                :items="urgencies"
                label="Urgency"
                clearable
              ></v-select>
            </v-flex> -->
            <!-- <v-flex xs12 sm4 class="pr-2">
              <v-select
                v-model="channel"
                :items="channels"
                label="Channel"
                clearable
              ></v-select>
            </v-flex> -->
            <v-flex xs12 sm4>
              <v-text-field
                v-model="actionUrl"
                label="Action URL"
                :rules="[rules.url]"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-btn
            color="success"
            :disabled="!canSend"
            :loading="sending"
            @click="send"
            >Send</v-btn
          >
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
function isValidActionUrl(value) {
  const text = value ? String(value).trim() : "";
  if (!text) return true;
  try {
    const parsed = new URL(text);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch (e) {
    return false;
  }
}

export default {
  data() {
    return {
      users: [],
      selectedUsers: [],
      title: "",
      description: "",
      urgency: "",
      channel: "",
      actionUrl: "",
      urgencies: ["LOW", "MEDIUM", "HIGH", "URGENT"],
      channels: ["Desktop", "Web"],
      loadingUsers: false,
      sending: false,
      rules: {
        required: (v) => !!(v && String(v).trim()) || "Required",
        titleLength: (v) =>
          !v || String(v).trim().length <= 255 || "255 characters or fewer",
        url: (v) => isValidActionUrl(v) || "Enter a valid URL",
      },
    };
  },
  computed: {
    allSelected() {
      return (
        this.users.length > 0 && this.selectedUsers.length === this.users.length
      );
    },
    canSend() {
      const title = (this.title || "").trim();
      const description = (this.description || "").trim();
      return (
        this.selectedUsers.length > 0 &&
        title.length > 0 &&
        title.length <= 255 &&
        description.length > 0 &&
        isValidActionUrl(this.actionUrl)
      );
    },
  },
  created() {
    this.loadUsers();
  },
  methods: {
    async loadUsers() {
      this.loadingUsers = true;
      try {
        const response = await this.$http.get(
          "/odata/users?$select=userName,name,disabled&$orderby=userName"
        );
        const rows = (response && response.value) || [];
        this.users = rows
          .filter((u) => u.disabled !== true && u.userName)
          .map((u) => ({
            userName: u.userName,
            label: u.name ? u.userName + " (" + u.name + ")" : u.userName,
          }));
      } catch (e) {
        this.users = [];
      } finally {
        this.loadingUsers = false;
      }
    },
    toggleAll() {
      this.selectedUsers = this.allSelected
        ? []
        : this.users.map((u) => u.userName);
    },
    async send() {
      if (!this.canSend || this.sending) return;
      this.sending = true;
      try {
        const created = await this.$http.post(
          "api/NotificationMessages/CreateNotification",
          {
            users: this.selectedUsers,
            title: this.title.trim(),
            description: this.description.trim(),
            urgency: this.urgency || "",
            channel: this.channel || "",
            actionUrl: this.actionUrl ? this.actionUrl.trim() : "",
          }
        );
        const count = Array.isArray(created) ? created.length : 0;
        this.$notify({
          group: "notification",
          text: "Sent " + count + " notification" + (count === 1 ? "" : "s"),
          type: "success",
        });
        this.$router.go(0);
      } catch (e) {
        // error already surfaced by http interceptor
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
